import type {
  ContentfulFooterFragment,
  ContentfulMainHeaderFragment,
} from '@/graphql/contentful/api';

export const cmsDefaultData = {
  header: {
    __typename: 'MainHeader',
    internalName: 'Layout Header',
    background: 'white',
    textColorOption: 'dark',
    megamenu: {
      __typename: 'MegaMenu',
      internalName: 'Default Megamenu',
      image: null,
      menuItemsCollection: {
        __typename: 'MegaMenuMenuItemsCollection',
        items: [
          {
            __typename: 'MainMenuItem',
            submenuItemsCollection: {
              __typename: 'MainMenuItemSubmenuItemsCollection',
              items: [
                {
                  __typename: 'MainMenuItem',
                  submenuItemsCollection: {
                    __typename: 'MainMenuItemSubmenuItemsCollection',
                    items: [
                      {
                        __typename: 'MainMenuItem',
                        internalName: 'Our history',
                        type: 'Link',
                        label: 'Our history',
                        url: '/history',
                        visibleInDesktop: true,
                        visibleInMobile: true,
                        image: null,
                        sys: {
                          __typename: 'Sys',
                          id: 'our-history-item',
                        },
                      },
                    ],
                  },
                  internalName: 'Discover',
                  type: 'Title',
                  label: 'Discover',
                  url: null,
                  visibleInDesktop: true,
                  visibleInMobile: true,
                  image: null,
                  sys: {
                    __typename: 'Sys',
                    id: 'discover-item',
                  },
                },
              ],
            },
            sys: {
              __typename: 'Sys',
              id: '5P6hYUGc9J2hoPPgY9qYeR',
            },
            internalName: 'About',
            type: 'Title',
            label: 'About',
            url: null,
            visibleInDesktop: true,
            visibleInMobile: true,
            image: {
              __typename: 'Asset',
              title: "Chronomat women's",
              contentType: 'image/png',
              width: 512,
              height: 824,
              url: '://images.ctfassets.net/11yu5j5b14kx/4m4Q4JSJxjf3E0eEubg8RA/22cf3365bb622b4e3cf8a03e019fb4f4/end-image-chronomat-womens-1.png',
              sys: {
                __typename: 'Sys',
                id: '4m4Q4JSJxjf3E0eEubg8RA',
              },
            },
          },
        ],
      },
      sys: {
        __typename: 'Sys',
        id: '3LK72nHHmbPWJ6otrJLt3d',
      },
    },
    searchOverlay: {
      __typename: 'SearchOverlay',
      sys: {
        __typename: 'Sys',
        id: '7jRrrriPGmUlCuaqJqWReW',
      },
      type: 'Default',
      title: 'Search',
      searchBox: 'What are you looking for',
      displayRetailers: true,
    },
    alertBannerCollection: {
      __typename: 'MainHeaderAlertBannerCollection',
      items: [
        {
          __typename: 'AlertBanner',
          internalName: 'Default Alert Banner',
          type: 'Default',
          alertBannerText: {
            __typename: 'AlertBannerText',
            json: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Lorem ipsum ...',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
          },
          sys: {
            __typename: 'Sys',
            id: '63skUbZMdPun4jhSQ6I96y',
          },
        },
      ],
    },
    sys: {
      __typename: 'Sys',
      id: '3U6RMWZ1KrFhX9tQ5gxIFk',
    },
  } as ContentfulMainHeaderFragment,
  footer: {
    __typename: 'Footer',
    internalName: 'Layout Footer',
    type: 'Default',
    menuItemsCollection: {
      __typename: 'FooterMenuItemsCollection',
      items: [
        {
          __typename: 'MainMenuItem',
          submenuItemsCollection: {
            __typename: 'MainMenuItemSubmenuItemsCollection',
            items: [
              {
                __typename: 'MainMenuItem',
                internalName: '#Squadonmissiontodobetter',
                type: 'Link',
                label: '#Squadonmissiontodobetter',
                url: null,
                visibleInDesktop: true,
                visibleInMobile: true,
                sys: {
                  __typename: 'Sys',
                  id: 'squad-item',
                },
              },
            ],
          },
          internalName: 'Customer Care',
          type: 'Title',
          label: 'Customer Care',
          url: null,
          visibleInDesktop: true,
          visibleInMobile: true,
          sys: {
            __typename: 'Sys',
            id: 'customer-care-item',
          },
        },
      ],
    },
    sys: {
      __typename: 'Sys',
      id: '6xXfNXws1Zus6yJ2L1eHRE',
    },
  } as ContentfulFooterFragment,
};

export const Countries = {
  countries: [
    {
      slug: 'dz',
      locales: {
        fr: 'français',
        enUS: 'English',
      },
      name: 'Algeria',
      favorite: false,
      continent: 'Africa',
    },
    {
      slug: 'ci',
      locales: {
        enUS: 'English',
        fr: 'français',
      },
      name: 'Côte d’Ivoire',
      favorite: false,
      continent: 'Africa',
    },
    {
      slug: 'mu',
      locales: {
        enUS: 'English',
        fr: 'français',
      },
      name: 'Mauritius',
      favorite: false,
      continent: 'Africa',
    },
    {
      slug: 'ma',
      locales: {
        enUS: 'English',
        fr: 'français',
      },
      name: 'Morocco',
      favorite: true,
      continent: 'Africa',
    },
    {
      slug: 'na',
      locales: {
        enUS: 'English',
      },
      name: 'Namibia',
      favorite: false,
      continent: 'Africa',
    },
    {
      slug: 're',
      locales: {
        enUS: 'English',
        fr: 'français',
      },
      name: 'Réunion',
      favorite: true,
      continent: 'Africa',
    },
    {
      slug: 'za',
      locales: {
        enUS: 'English',
      },
      name: 'South Africa',
      favorite: true,
      continent: 'Africa',
    },
    {
      slug: 'tn',
      locales: {
        enUS: 'English',
      },
      name: 'Tunisia',
      favorite: false,
      continent: 'Africa',
    },
    {
      slug: 'ag',
      locales: {
        enUS: 'English',
      },
      name: 'Antigua & Barbuda',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'ar',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Argentina',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'aw',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Aruba',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'bs',
      locales: {
        enUS: 'English',
      },
      name: 'Bahamas',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'bb',
      locales: {
        enUS: 'English',
      },
      name: 'Barbados',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'bz',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Belize',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'bm',
      locales: {
        enUS: 'English',
      },
      name: 'Bermuda',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'br',
      locales: {
        pt: 'português',
        enUS: 'English',
      },
      name: 'Brazil',
      favorite: true,
      continent: 'America',
    },
    {
      slug: 'vg',
      locales: {
        enUS: 'English',
      },
      name: 'British Virgin Islands',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'ca',
      locales: {
        enUS: 'English',
        fr: 'français',
        zh: '中文（简体）',
      },
      name: 'Canada',
      favorite: true,
      continent: 'America',
    },
    {
      slug: 'ky',
      locales: {
        enUS: 'English',
      },
      name: 'Cayman Islands',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'cl',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Chile',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'co',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Colombia',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'cr',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Costa Rica',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'cw',
      locales: {
        enUS: 'English',
      },
      name: 'Curaçao',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'dm',
      locales: {
        enUS: 'English',
      },
      name: 'Dominica',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'do',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Dominican Republic',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'gt',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Guatemala',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'hn',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Honduras',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'jm',
      locales: {
        enUS: 'English',
      },
      name: 'Jamaica',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'mx',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Mexico',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'pa',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Panama',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'py',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Paraguay',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'pe',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Peru',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'pr',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Puerto Rico',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'sx',
      locales: {
        enUS: 'English',
      },
      name: 'Sint Maarten',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'bl',
      locales: {
        enUS: 'English',
        fr: 'français',
      },
      name: 'St. Barthélemy',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'kn',
      locales: {
        enUS: 'English',
      },
      name: 'St. Kitts & Nevis',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'lc',
      locales: {
        enUS: 'English',
        fr: 'français',
      },
      name: 'St. Lucia',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'mf',
      locales: {
        enUS: 'English',
      },
      name: 'St. Martin',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'tc',
      locales: {
        enUS: 'English',
      },
      name: 'Turks & Caicos Islands',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'vi',
      locales: {
        enUS: 'English',
      },
      name: 'U.S. Virgin Islands',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'us',
      locales: {
        enUS: 'English',
        es: 'español',
        zh: '中文（简体）',
      },
      name: 'United States',
      favorite: true,
      continent: 'America',
    },
    {
      slug: 'uy',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Uruguay',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 've',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Venezuela',
      favorite: false,
      continent: 'America',
    },
    {
      slug: 'bn',
      locales: {
        enUS: 'English',
      },
      name: 'Brunei',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'kh',
      locales: {
        enUS: 'English',
      },
      name: 'Cambodia',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'cn',
      locales: {
        zh: '中文（简体）',
        enUS: 'English',
      },
      name: 'China',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'hk',
      locales: {
        zht: '中文（繁體）',
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Hong Kong SAR China',
      favorite: true,
      continent: 'Asia',
    },
    {
      slug: 'in',
      locales: {
        enUS: 'English',
      },
      name: 'India',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'id',
      locales: {
        enUS: 'English',
      },
      name: 'Indonesia',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'jp',
      locales: {
        ja: '日本語',
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Japan',
      favorite: true,
      continent: 'Asia',
    },
    {
      slug: 'kz',
      locales: {
        ru: 'русский',
        enUS: 'English',
      },
      name: 'Kazakhstan',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'kg',
      locales: {
        enUS: 'English',
        ru: 'русский',
      },
      name: 'Kyrgyzstan',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'la',
      locales: {
        enUS: 'English',
      },
      name: 'Laos',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'mo',
      locales: {
        zh: '中文（简体）',
        enUS: 'English',
      },
      name: 'Macao SAR China',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'my',
      locales: {
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Malaysia',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'mm',
      locales: {
        enUS: 'English',
      },
      name: 'Myanmar (Burma)',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'ph',
      locales: {
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Philippines',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'sg',
      locales: {
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Singapore',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'kr',
      locales: {
        ko: '한국어',
        enUS: 'English',
        zht: '中文（繁體）',
      },
      name: 'South Korea',
      favorite: true,
      continent: 'Asia',
    },
    {
      slug: 'lk',
      locales: {
        enUS: 'English',
      },
      name: 'Sri Lanka',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'tw',
      locales: {
        zht: '中文（繁體）',
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Taiwan Region China',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'tj',
      locales: {
        enUS: 'English',
      },
      name: 'Tajikistan',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'th',
      locales: {
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Thailand',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'tm',
      locales: {
        enUS: 'English',
      },
      name: 'Turkmenistan',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'uz',
      locales: {
        enUS: 'English',
      },
      name: 'Uzbekistan',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'vn',
      locales: {
        enUS: 'English',
      },
      name: 'Vietnam',
      favorite: false,
      continent: 'Asia',
    },
    {
      slug: 'al',
      locales: {
        enUS: 'English',
      },
      name: 'Albania',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'ad',
      locales: {
        es: 'español',
        enUS: 'English',
      },
      name: 'Andorra',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'am',
      locales: {
        enUS: 'English',
      },
      name: 'Armenia',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'at',
      locales: {
        de: 'Deutsch',
        enUS: 'English',
      },
      name: 'Austria',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'az',
      locales: {
        enUS: 'English',
      },
      name: 'Azerbaijan',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'by',
      locales: {
        enUS: 'English',
        ru: 'русский',
      },
      name: 'Belarus',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'be',
      locales: {
        fr: 'français',
        enUS: 'English',
      },
      name: 'Belgium',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'ba',
      locales: {
        enUS: 'English',
      },
      name: 'Bosnia & Herzegovina',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'bg',
      locales: {
        enUS: 'English',
      },
      name: 'Bulgaria',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'hr',
      locales: {
        enUS: 'English',
      },
      name: 'Croatia',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'cy',
      locales: {
        enUS: 'English',
      },
      name: 'Cyprus',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'cz',
      locales: {
        enUS: 'English',
      },
      name: 'Czechia',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'dk',
      locales: {
        enUS: 'English',
      },
      name: 'Denmark',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'ee',
      locales: {
        enUS: 'English',
      },
      name: 'Estonia',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'fi',
      locales: {
        enUS: 'English',
      },
      name: 'Finland',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'fr',
      locales: {
        fr: 'français',
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'France',
      favorite: true,
      continent: 'Europe',
    },
    {
      slug: 'ge',
      locales: {
        enUS: 'English',
      },
      name: 'Georgia',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'de',
      locales: {
        de: 'Deutsch',
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Germany',
      favorite: true,
      continent: 'Europe',
    },
    {
      slug: 'gi',
      locales: {
        enUS: 'English',
      },
      name: 'Gibraltar',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'gr',
      locales: {
        enUS: 'English',
      },
      name: 'Greece',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'hu',
      locales: {
        enUS: 'English',
      },
      name: 'Hungary',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'ie',
      locales: {
        enUS: 'English',
      },
      name: 'Ireland',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'it',
      locales: {
        it: 'italiano',
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Italy',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'xk',
      locales: {
        enUS: 'English',
      },
      name: 'Kosovo',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'lv',
      locales: {
        enUS: 'English',
      },
      name: 'Latvia',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'li',
      locales: {
        de: 'Deutsch',
        enUS: 'English',
      },
      name: 'Liechtenstein',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'lt',
      locales: {
        enUS: 'English',
      },
      name: 'Lithuania',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'lu',
      locales: {
        de: 'Deutsch',
        enUS: 'English',
        fr: 'français',
      },
      name: 'Luxembourg',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'mt',
      locales: {
        enUS: 'English',
      },
      name: 'Malta',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'md',
      locales: {
        enUS: 'English',
      },
      name: 'Moldova',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'mc',
      locales: {
        enUS: 'English',
        fr: 'français',
        it: 'italiano',
      },
      name: 'Monaco',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'me',
      locales: {
        enUS: 'English',
      },
      name: 'Montenegro',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'nl',
      locales: {
        enUS: 'English',
      },
      name: 'Netherlands',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'mk',
      locales: {
        enUS: 'English',
      },
      name: 'North Macedonia',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'no',
      locales: {
        enUS: 'English',
      },
      name: 'Norway',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'pl',
      locales: {
        enUS: 'English',
      },
      name: 'Poland',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'pt',
      locales: {
        pt: 'português',
        enUS: 'English',
      },
      name: 'Portugal',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'ro',
      locales: {
        enUS: 'English',
      },
      name: 'Romania',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'ru',
      locales: {
        ru: 'русский',
        enUS: 'English',
      },
      name: 'Russia',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'rs',
      locales: {
        enUS: 'English',
      },
      name: 'Serbia',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'sk',
      locales: {
        enUS: 'English',
      },
      name: 'Slovakia',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'si',
      locales: {
        enUS: 'English',
      },
      name: 'Slovenia',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'es',
      locales: {
        es: 'español',
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Spain',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'se',
      locales: {
        enUS: 'English',
      },
      name: 'Sweden',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'ch',
      locales: {
        fr: 'français',
        de: 'Deutsch',
        it: 'italiano',
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Switzerland',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'tr',
      locales: {
        enUS: 'English',
      },
      name: 'Türkiye',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'ua',
      locales: {
        enUS: 'English',
      },
      name: 'Ukraine',
      favorite: false,
      continent: 'Europe',
    },
    {
      slug: 'gb',
      locales: {
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'United Kingdom',
      favorite: true,
      continent: 'Europe',
    },
    {
      slug: 'bh',
      locales: {
        enUS: 'English',
      },
      name: 'Bahrain',
      favorite: false,
      continent: 'Middle East',
    },
    {
      slug: 'eg',
      locales: {
        enUS: 'English',
        fr: 'français',
      },
      name: 'Egypt',
      favorite: false,
      continent: 'Middle East',
    },
    {
      slug: 'ir',
      locales: {
        enUS: 'English',
      },
      name: 'Iran',
      favorite: false,
      continent: 'Middle East',
    },
    {
      slug: 'iq',
      locales: {
        enUS: 'English',
      },
      name: 'Iraq',
      favorite: false,
      continent: 'Middle East',
    },
    {
      slug: 'il',
      locales: {
        enUS: 'English',
      },
      name: 'Israel',
      favorite: false,
      continent: 'Middle East',
    },
    {
      slug: 'jo',
      locales: {
        enUS: 'English',
      },
      name: 'Jordan',
      favorite: true,
      continent: 'Middle East',
    },
    {
      slug: 'kw',
      locales: {
        enUS: 'English',
      },
      name: 'Kuwait',
      favorite: false,
      continent: 'Middle East',
    },
    {
      slug: 'lb',
      locales: {
        enUS: 'English',
      },
      name: 'Lebanon',
      favorite: false,
      continent: 'Middle East',
    },
    {
      slug: 'om',
      locales: {
        enUS: 'English',
      },
      name: 'Oman',
      favorite: false,
      continent: 'Middle East',
    },
    {
      slug: 'qa',
      locales: {
        enUS: 'English',
      },
      name: 'Qatar',
      favorite: false,
      continent: 'Middle East',
    },
    {
      slug: 'sa',
      locales: {
        enUS: 'English',
      },
      name: 'Saudi Arabia',
      favorite: true,
      continent: 'Middle East',
    },
    {
      slug: 'ae',
      locales: {
        enUS: 'English',
      },
      name: 'United Arab Emirates',
      favorite: true,
      continent: 'Middle East',
    },
    {
      slug: 'au',
      locales: {
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'Australia',
      favorite: false,
      continent: 'Oceania',
    },
    {
      slug: 'fj',
      locales: {
        enUS: 'English',
      },
      name: 'Fiji',
      favorite: false,
      continent: 'Oceania',
    },
    {
      slug: 'nc',
      locales: {
        enUS: 'English',
      },
      name: 'New Caledonia',
      favorite: false,
      continent: 'Oceania',
    },
    {
      slug: 'nz',
      locales: {
        enUS: 'English',
        zh: '中文（简体）',
      },
      name: 'New Zealand',
      favorite: false,
      continent: 'Oceania',
    },
    {
      slug: 'mp',
      locales: {
        enUS: 'English',
      },
      name: 'Northern Mariana Islands',
      favorite: false,
      continent: 'Oceania',
    },
  ],
};

export const Regions = {
  data: [
    {
      name: 'Africa',
      code: 'africa',
    },
    {
      name: 'America',
      code: 'america',
    },
    {
      name: 'Asia',
      code: 'asia',
    },
    {
      name: 'Europe',
      code: 'europe',
    },
    {
      name: 'Middle East',
      code: 'middleEast',
    },
    {
      name: 'Oceania',
      code: 'oceania',
    },
  ],
};
